<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-24 14:35:51
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-14 18:26:16
 * @FilePath: /goldenSalesMobile/src/views/404.vue
 * @Description: 
-->
<template>
  <div class='page-container'>
    <div class="not-found-img">
      <img
        src="../assets/common_image/sorry.png"
        alt=""
      >
    </div>
    <p class="not-found-txt">很抱歉没有找到您要访问的页面</p>
    <div class="fixed-btn">
      <van-button
        block
        color="linear-gradient(to right, #FA9B00, #FBCA39)"
        @click="onBack"
      >
        返回首页
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },

  created() {

  },

  methods: {
    onBack() {
      // this.$router.back()
      this.$router.replace({ path: '/' })
    }
  }

}
</script>

<style lang='scss' scoped>
.page-container {
  background: $blockBgColor;

  .not-found-img {
    width: 313px;
    height: 194px;
    margin: 300px auto 50px;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .not-found-txt {
    font-size: 28px;
    text-align: center;
    line-height: 34px;
    color: #999;
  }
}
</style>

